import React from 'react';
import type { FC, PropsWithChildren } from 'react';

import StyledGridContainer from './styled-components/StyledGridContainer';

const ContentContainer: FC<PropsWithChildren> = ({
  children,
}) => {
  return (
    <StyledGridContainer
      id="contentRoot"
      container
      direction="column"
    >
      {children}
    </StyledGridContainer>
  );
};

export default ContentContainer;
